import React from 'react';
import { Link } from 'react-router-dom';
import { Clock } from 'lucide-react'; // Using Lucide for a more modern icon
import '../styles/Blog.css';

function Blog() {
  const comingSoonPost = {
    id: 1,
    title: "Coming Soon",
    excerpt: "Stay tuned for exciting updates and insights.",
    date: new Date().toISOString(), // Current date
    icon: <Clock strokeWidth={1.5} size={24} className="blog-icon" />
  };

  return (
    <div className="blog-container">
      <h2>Latest Updates</h2>
      <div className="blog-cards">
        <div className="blog-card coming-soon">
          <div className="blog-card-header">
            {comingSoonPost.icon}
            <span className="blog-date">
              {new Date(comingSoonPost.date).toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
              })}
            </span>
          </div>
          <h3>{comingSoonPost.title}</h3>
          <p>{comingSoonPost.excerpt}</p>
        </div>
      </div>
    </div>
  );
}

export default Blog;